export default __webpack_public_path__ + "static/media/bitmoji.0f436a9e.png";